import type { EntityField } from '../components/entity-catalog/entity-catalog.types';
import { stringifyUnknownFieldValue } from './client-list.util';

function statusKeyFromValue(value: unknown): string {
  if (typeof value === 'boolean') {
    return value ? 'Active' : 'InActive';
  }
  return stringifyUnknownFieldValue(value);
}

/** Human-readable label for catalog status / boolean active columns. */
export function catalogStatusLabel(value: unknown, field?: EntityField): string {
  if (typeof value === 'boolean') {
    return value ? 'Active' : 'Inactive';
  }
  const raw = stringifyUnknownFieldValue(value, '—');
  if (raw === 'InActive') return 'Inactive';
  if (raw === 'ACTIVE') return 'Active';
  if (raw === 'DISABLED') return 'Disabled';
  if (raw === 'DRAFT') return 'Draft';
  if (raw === 'PUBLISHED') return 'Published';
  if (field?.kind === 'enum') {
    return raw.charAt(0) + raw.slice(1).toLowerCase();
  }
  return raw;
}

/** Tailwind badge classes aligned with manage-users status pills. */
export function catalogStatusBadgeClass(value: unknown): Record<string, boolean> {
  const s = statusKeyFromValue(value);
  return {
    'text-success bg-success-light dark:bg-success/15 dark:text-success': s === 'Active' || s === 'ACTIVE' || s === 'PUBLISHED',
    'text-secondary bg-secondary-light dark:bg-white/10 dark:text-gray-300':
      s === 'InActive' || s === 'INACTIVE' || s === 'DISABLED' || s === 'false',
    'text-warning bg-warning-light dark:bg-warning/15 dark:text-warning':
      s === 'DRAFT' || s === 'BETA' || s === 'Suspended' || s === 'Locked',
    'text-danger bg-danger-light dark:bg-danger/15 dark:text-danger': s === 'Blocked',
  };
}
